const NODE_LABELS: Record<string, string> = {
    analyzeDeepLink: 'Destination page analysis',
    ingestPageImages: 'Linked page images',
    processVideo: 'Ad video processing',
    analyzeAdCreative: 'Ad creative analysis',
    resolveProducts: 'Product selection',
    ingestProductImages: 'Product page images',
    generateConversionHypothesis: 'Conversion hypothesis',
    rankPersonas: 'Audience ranking',
    rankLayoutReferences: 'Creative direction',
    prepareProductContent: 'Product content prep',
    planVariants: 'Variant planning',
    analyzeLayoutReference: 'Direction breakdown',
    createStorefront: 'Storefront draft',
    generateLlmContent: 'Content writing',
    curateMedia: 'Media curation',
    finalizeContent: 'Finalizing storefront',
    rewriteCopy: 'Copy polish',
    reviewStorefronts: 'Quality review',
    reviseStorefronts: 'Review fixes',
}

const NODE_RUNNING_LABELS: Record<string, string> = {
    analyzeDeepLink: 'Analyzing the destination page',
    ingestPageImages: 'Scanning linked pages for images',
    processVideo: 'Processing the ad video',
    analyzeAdCreative: 'Reading the ad creative',
    resolveProducts: 'Pulling products and checking stock',
    ingestProductImages: 'Scanning product pages for images',
    generateConversionHypothesis: 'Forming a conversion hypothesis',
    rankPersonas: 'Ranking audience personas',
    rankLayoutReferences: 'Exploring creative directions for this ad',
    prepareProductContent: 'Pulling product details and variants',
    planVariants: 'Planning storefront variants',
    analyzeLayoutReference: 'Breaking the direction down into sections',
    createStorefront: 'Creating the storefront draft',
    generateLlmContent: 'Writing storefront content',
    curateMedia: 'Curating imagery',
    finalizeContent: 'Finalizing the storefront',
    rewriteCopy: 'Polishing page copy',
    reviewStorefronts: 'Reviewing the storefront',
    reviseStorefronts: 'Applying review fixes',
}

function formatNodeName(node: string): string {
    return node
        .replace(/([A-Z])/g, ' $1')
        .toLowerCase()
        .trim()
}

export function getNodeLabel(node: string): string {
    return NODE_LABELS[node] ?? formatNodeName(node)
}

export function getNodeRunningLabel(node: string): string {
    return NODE_RUNNING_LABELS[node] ?? `${formatNodeName(node)}…`
}
